import {
  getDescriptionFromBookingFormGroup,
  getModalsFromBookingFormGroup,
  getTitleFromBookingFormGroup,
  isBookingFormGroupSection,
} from "../../lib/bookingFormHelpers";
import { toArray } from "../../lib/functions";
import { getElementsFromBookingFormGroup } from "./getElementsFromBookingFormGroup";

export function getSectionsFromAcquisitionParamsBookingForm(
  acquisitionParamsBookingForm,
  cbt,
  acquisitionParamsBookingFormAlerts
) {
  if (!acquisitionParamsBookingForm) {
    return [];
  }

  const sections = [];

  acquisitionParamsBookingForm.forEach((bookingFormGroup) => {
    if (isBookingFormGroupSection(bookingFormGroup)) {
      return sections.push({
        title: bookingFormGroup.Label.$t,
        alert: acquisitionParamsBookingFormAlerts,
        elements: getElementsFromBookingFormGroup({
          bookingFormGroup,
          passengerIndex: undefined,
          cbt,
        }),
        code: bookingFormGroup.Code,
      });
    }

    if (
      bookingFormGroup?.BookingFormGroup?.BookingFormGroup &&
      Array.isArray(bookingFormGroup.BookingFormGroup.BookingFormGroup)
    ) {
      bookingFormGroup.BookingFormGroup.BookingFormGroup.forEach(
        (bookingFormGroupInsideGroup) => {
          if (isBookingFormGroupSection(bookingFormGroupInsideGroup)) {
            return sections.push({
              alert: acquisitionParamsBookingFormAlerts,
              title: getTitleFromBookingFormGroup({
                bookingFormGroup: bookingFormGroupInsideGroup,
                bookingFormGroupAbove: bookingFormGroup.BookingFormGroup,
              }),
              description: getDescriptionFromBookingFormGroup({
                bookingFormGroup: bookingFormGroupInsideGroup,
              }),
              modals: getModalsFromBookingFormGroup({
                bookingFormGroup: bookingFormGroupInsideGroup,
              }),
              elements: getElementsFromBookingFormGroup({
                bookingFormGroup: bookingFormGroupInsideGroup,
                passengerIndex: !bookingFormGroupInsideGroup?.Code?.includes(
                  "marketplace"
                )
                  ? 0
                  : undefined,
                cbt,
              }),
              code: bookingFormGroupInsideGroup.Code,
            });
          }
        }
      );

      return;
    }

    if (isBookingFormGroupSection(bookingFormGroup.BookingFormGroup)) {
      return sections.push({
        title: bookingFormGroup.BookingFormGroup.Label.$t,
        alert: acquisitionParamsBookingFormAlerts,
        elements: getElementsFromBookingFormGroup({
          bookingFormGroup: bookingFormGroup.BookingFormGroup,
          passengerIndex: undefined,
          cbt,
        }),
        code: bookingFormGroup.BookingFormGroup.Code,
      });
    }

    // especially multiple passengers
    if (Array.isArray(bookingFormGroup.BookingFormGroup)) {
      bookingFormGroup.BookingFormGroup.forEach((bookingFormGroupInside) => {
        toArray(bookingFormGroupInside.BookingFormGroup).forEach(
          (bookingFormGroupInsideInside) => {
            if (isBookingFormGroupSection(bookingFormGroupInsideInside)) {
              return sections.push({
                alert: acquisitionParamsBookingFormAlerts,
                title: getTitleFromBookingFormGroup({
                  bookingFormGroup: bookingFormGroupInsideInside,
                  bookingFormGroupAbove: bookingFormGroupInside,
                }),
                description: getDescriptionFromBookingFormGroup({
                  bookingFormGroup: bookingFormGroupInsideInside,
                }),
                modals: getModalsFromBookingFormGroup({
                  bookingFormGroup: bookingFormGroupInsideInside,
                }),
                elements: getElementsFromBookingFormGroup({
                  bookingFormGroup: bookingFormGroupInsideInside,
                  passengerIndex: bookingFormGroupInside.Index,
                  cbt,
                }),
                code: bookingFormGroupInsideInside.Code,
              });
            }
          }
        );
      });
    }

    // hotel travelers
    if (
      bookingFormGroup?.BookingFormGroup?.BookingFormGroup &&
      isBookingFormGroupSection(
        bookingFormGroup.BookingFormGroup.BookingFormGroup
      )
    ) {
      return sections.push({
        alert: acquisitionParamsBookingFormAlerts,
        title: getTitleFromBookingFormGroup({
          bookingFormGroup: bookingFormGroup.BookingFormGroup.BookingFormGroup,
          bookingFormGroupAbove: bookingFormGroup.BookingFormGroup,
        }),
        description: getDescriptionFromBookingFormGroup({
          bookingFormGroup: bookingFormGroup.BookingFormGroup.BookingFormGroup,
        }),
        modals: getModalsFromBookingFormGroup({
          bookingFormGroup: bookingFormGroup.BookingFormGroup.BookingFormGroup,
        }),
        elements: getElementsFromBookingFormGroup({
          bookingFormGroup: bookingFormGroup.BookingFormGroup.BookingFormGroup,
          passengerIndex: !bookingFormGroup?.Code?.includes("marketplace")
            ? 0
            : undefined,
          cbt,
        }),
        code: bookingFormGroup.BookingFormGroup.Code,
      });
    }
  });

  return sections;
}
